export default "__VITE_ASSET__3zXmYoQ0__"